module.exports = __webpack_public_path__ + "static/media/CarsAndBicycle.ca31a4dd.png";